import type { CookieStorage } from "@shared/cookieStorage";
import type { StoreApi, UseBoundStore } from "zustand";

export const CTA_BUTTON_TEXTS = {
  ADD: "Legg i handlekurv",
  UPDATE: "Lagre",
};

export type ShoppingCartStoreOptions = {
  cookieJar: CookieStorage;
  namespace: string;
  isMbb: boolean;
  isBusiness: boolean;
  maxOrders: number;
  shippingPriceMbb: number;
};

export interface VoiceShopStoreStateModel {
  offerings: Offering[];
  updateService: (productId: string, serviceId: string, selected: boolean) => void;
  updateServiceAndDeselectOthers: (productId: string, serviceId: string, selected: boolean) => void;
  getOffering: (id: string) => Offering | undefined;
  removeOffering: (id: string) => void;
  numberOfProducts: () => number;
  getPrice: () => Prices;
  addMbbOffering: (model: MbbBundle) => string;
  addVoiceOffering: (model: Subscription) => string;
  getOfferings: () => Offering[];
  getMaxOrders: () => number;
  isMbb: () => boolean;
  isBusiness: () => boolean;
}

export type voiceShopStoreStateType = UseBoundStore<StoreApi<VoiceShopStoreStateModel>>;

export type BaseOfferingType = {
  name: string;
  viewName: string;
  offeringId: string;
  offeringType: "Voice" | "MBB";
};

export type BaseAdditionalServices = {
  selected: boolean;
  serviceId: string;
};

export type AdditionalServices = BaseAdditionalServices & {
  title: string;
  price: number;
};

export type productPageType = "plp" | "pdp" | "frontpage";

export type Subscription = BaseOfferingType & {
  offeringType: "Voice";
  additionalServices?: AdditionalServices[] | null;
  planId: string;
  price: number;
  pricenocampaign: number;
  blockId: string;
  builderUrl: string;
  showExternalServiceDialog: boolean;
  productPage: productPageType;
  analyticsListName: string;
  isCampaign: boolean;
  campaignPeriod: number;
};

export type baseMbbBundle = BaseOfferingType & {
  planId: string;
};

export type MbbBundle = baseMbbBundle & {
  offeringType: "MBB";
  routername: string;
  monthlyprice: number;
  subscriptionname: string;
  monthlypricenocampaign: number;
  routerId: string;
  subscriptionId: string;
  routerprice: number;
  isbusiness: boolean;
  productName?: string;
  analyticsListName?: string;
};

export type MbbBundleEvent = {
  mbbBundle: MbbBundle;
  openButton: HTMLElement;
};

export type Offering = Subscription | MbbBundle;

export type UpdateSubscriptionServicesModel = {
  sessionId: string;
  blockId: string;
  services: BaseAdditionalServices[];
};

export type ShoppingCartTransferModel = {
  sessionId: string;
  blockId: string;
  openButton: HTMLElement;
  openFromShoppingCart: boolean;
  update: boolean;
  services?: BaseAdditionalServices[];
  baseUrl: string;
  adding?: boolean;
  productPage: productPageType;
  preselectServiceId: "";
  analyticsListname: string;
};

export type VoiceAddToCartEvent = {
  sub: Subscription;
};

export type MbbPrices = {
  total: number;
  totalAfterCampaign: number;
  shippingPrice: number;
  totalUpfront: number;
};

export type VoicePrices = {
  total: number;
};

export type Prices = MbbPrices | VoicePrices;

export type AbstractSubscriptionInfo = {
  id: string;
  name: string;
};
